import React, { Component } from "react";
import DKLabel from "./common/DKLabel";
import DKButton from "./common/DKButton";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className="row pl-r p-v-s parent-width border-box justify-content-between position-sticky"
        style={{ backgroundColor: "rgb(90, 100, 215)", top: 0 }}
      >
        <div>
          <div className="row">
            {/* <DKIcon src={ic_piyush_1} className="ic-m mr-r display-only-web" /> */}
            <DKLabel text="Dev. by Piyush ✌🏻" className="text-white" />
          </div>
        </div>
        <div>
          <div className="row">
            <DKButton title="About" className="text-white" />
            <DKButton title="Projects" className="text-white" />
            <DKButton title="Contact 👦🏻" className="text-white" />
            {/* <div className="display-only-web">
              <DKButton
                title="Linkedin Profile"
                icon={ic_linkedin}
                className="text-white display-only-web"
              />
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Menu;
